require([
	'lodash',
	'json!etc/modules.json',
	'es6-promise',
	'modernizr'
], function(
	_,
	Modules,
	ES6Promise
) {
	ES6Promise.polyfill();

	function App() {}
	App.prototype = {
		bootstrap: function() {
			this.bootstrapModules();
		},

		bootstrapModules: function() {
			var self = this;
			var activePackages = _.map(_.filter(Modules, function(module) {
				return !!module.active;
			}), 'package');

			require(activePackages, function() {
				var packages = Array.prototype.slice.call(arguments, 0);
				_.forEach(packages, function(modulePackage) {
					if ('bootstrap' in modulePackage) {
						modulePackage.bootstrap();
					}
				});
			});
		}
	};

	var app = new App();
	app.bootstrap();
});
define("skin/frontend/gigaset/rebrush/js/gigaset.js", function(){});

